// Admin utilities for subscription system management
export class AdminUtils {
  // Run migration for all users
  static async runUserMigration(): Promise<void> {
    try {
      console.log('🚀 Starting user migration to new subscription system...');
      console.log('⚠️ Note: Migration now happens automatically on user login via LoadingPage');
      console.log('💡 Individual user migration is handled by migrateUserToNewSubscriptionSystem()');
      
      console.log('🎉 Migration system is ready and will handle users automatically!');
    } catch (error) {
      console.error('❌ Migration failed:', error);
      throw error;
    }
  }

  // Check migration status
  static async checkMigrationStatus(): Promise<any> {
    try {
      console.log('📊 Checking migration status...');
      console.log('⚠️ Note: Migration status checking is no longer available');
      console.log('💡 Migration now happens automatically on user login');
      console.log('🔍 Use migrationService.testSubscriptionCreation(userId) to test individual users');
      
      return { message: 'Migration is handled automatically on user login' };
    } catch (error) {
      console.error('❌ Failed to check migration status:', error);
      throw error;
    }
  }

  // Migrate old subscription format to new format
  static async migrateOldSubscriptionFormat(): Promise<void> {
    try {
      console.log('🔄 Starting old subscription format migration...');
      console.log('⚠️ Note: Old subscription format migration is no longer available');
      console.log('💡 Migration now happens automatically on user login via LoadingPage');
      console.log('🔧 All users get extended trial until 1/1/2026 with professional plan features');
      
      console.log('🎉 Migration system is ready and will handle users automatically!');
    } catch (error) {
      console.error('❌ Old subscription format migration failed:', error);
      throw error;
    }
  }

  // Get detailed migration report
  static async getDetailedMigrationReport(): Promise<{
    status: any;
    recommendations: string[];
  }> {
    try {
      console.log('📊 Getting detailed migration report...');
      console.log('⚠️ Note: Detailed migration reporting is no longer available');
      console.log('💡 Migration now happens automatically on user login');
      
      const recommendations: string[] = [
        'Migration is handled automatically on user login',
        'All users get extended trial until 1/1/2026'
      ];
      
      return {
        status: { message: 'Migration is handled automatically on user login' },
        recommendations
      };
    } catch (error) {
      console.error('❌ Failed to get detailed migration report:', error);
      throw error;
    }
  }
}

// Console commands for easy access
export const adminCommands = {
  // Run full migration
  migrate: () => AdminUtils.runUserMigration(),
  
  // Check status
  status: () => AdminUtils.checkMigrationStatus(),
  
  // Migrate old format
  migrateOld: () => AdminUtils.migrateOldSubscriptionFormat(),
  
  // Get detailed report
  report: () => AdminUtils.getDetailedMigrationReport()
};

      // Make commands available in console for easy access
    if (typeof window !== 'undefined') {
      (window as any).admin = adminCommands;
      (window as any).migrateUsers = async () => {
        try {
          console.log('🚀 Starting user migration...');
          console.log('⚠️ Note: Migration now happens automatically on user login');
          console.log('💡 Migration is handled automatically on user login');
          return { message: 'Migration is handled automatically on user login' };
        } catch (error) {
          console.error('❌ Migration failed:', error);
          throw error;
        }
      };
      
      
      // Test trial expiration function
      (window as any).testTrialExpiration = async () => {
        try {
          console.log('🧪 Setting up expired trial scenario...');
          const { doc, getDoc, updateDoc } = await import('firebase/firestore');
          const { db } = await import('../services/firestore');
          
          const TEST_USER_ID = 'hcqBWpoKxXfMs9Nm7u2PQMfJqUY2';
          const now = Date.now();
          const expiredTrialEndDate = now - (24 * 60 * 60 * 1000); // 1 day ago
          
          const userRef = doc(db, 'Users', TEST_USER_ID);
          const userDoc = await getDoc(userRef);
          
          if (!userDoc.exists()) {
            console.error('❌ User not found');
            return;
          }
          
          const userData = userDoc.data();
          const subscription = userData.subscription;
          
          if (!subscription) {
            console.error('❌ No subscription found');
            return;
          }
          
          // Use centralized date calculation
          const { TrialExtensionUtils } = require('../constants/trialExtension');
          const startDate = new Date(now - (15 * 24 * 60 * 60 * 1000)); // 15 days ago
          const endDate = TrialExtensionUtils.getPaidSubscriptionEndDate(new Date(now), 'monthly');
          
          const expiredTrialSubscription = {
            ...subscription,
            planId: 'professional',
            status: 'trial',
            startDate: startDate.getTime().toString(),
            endDate: endDate.getTime().toString(),
            totalPrice: 149,
            currency: 'EGP'
          };
          
          await updateDoc(userRef, {
            subscription: expiredTrialSubscription
          });
          
          console.log('✅ Expired trial subscription set up successfully');
          console.log('🔍 Now refresh the page to see the trial expired modal');
          
        } catch (error) {
          console.error('❌ Error setting up test:', error);
        }
      };
      
      console.log('🔧 Admin commands available:');
      console.log('admin.migrate() - Run full user migration');
      console.log('admin.status() - Check migration status');
      console.log('admin.migrateOld() - Migrate old subscription format');
      console.log('admin.report() - Get detailed migration report');
      console.log('migrateUsers() - Quick migration function');
      console.log('testTrialExpiration() - Set up expired trial scenario for testing');
    }

export default AdminUtils;
